<template>
  <div style="padding: 20px; background: #fff">
    <template v-for="(item, index) of curBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="clickHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'DetailFooterButtons',
    data() {
      return {
        allBtnList: [
          {
            title: '提交审批',
            type: 'primary',
            clickName: 'submit',
            params: 1,
            key: 'submit',
          },
          {
            title: '保存',
            type: 'primary',
            clickName: 'save',
            params: 1,
            key: 'save',
          },
          {
            title: '复制',
            type: 'primary',
            clickName: 'copy',
            params: 1,
            key: 'copy',
          },
          {
            title: '关闭合同',
            type: 'danger',
            clickName: 'close',
            params: 1,
            key: 'close',
          },
          {
            title: '激活合同',
            type: 'primary',
            clickName: 'activate',
            params: 1,
            key: 'activate',
          },
          {
            title: '删除',
            type: 'danger',
            clickName: 'delete',
            params: 1,
            key: 'delete',
          },
          {
            title: '申请撤销',
            type: 'primary',
            clickName: 'revocation',
            params: 1,
            key: 'revocation',
          },
          {
            title: '确认撤销',
            type: 'primary',
            clickName: 'sureRevocation',
            params: 1,
            key: 'sureRevocation',
          },
          {
            title: '驳回撤销',
            type: 'danger',
            clickName: 'cancelRevocation',
            params: 1,
            key: 'cancelRevocation',
          },
        ],
        curBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    mounted() {
      const status = this.$route.query.status ? this.$route.query.status : '';
      const contractStatus = this.$route.query.contractStatus
        ? this.$route.query.contractStatus
        : '';
      this.buttonStatusChange(status, contractStatus);
      console.log(status, '详情页面状态');
      console.log(contractStatus, '合同状态');
    },
    methods: {
      // 动态派发事件上去
      clickHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      buttonStatusChange(status, contractStatus) {
        this.curBtnList = this.allBtnList.map((item) => {
          if (status == 'create') {
            //新增页面按钮
            if (['save', 'submit'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (status == 'detail') {
            //详情页面按钮
            if (contractStatus == 'ZT00') {
              //已保存
              if (['save', 'submit', 'delete'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == 'ZT061') {
              //修订中
              if (['save', 'submit'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == 'ZT05') {
              //已驳回
              if (['save', 'submit', 'delete'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == 'ZT051') {
              //修订已驳回
              if (['save', 'submit'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == 'ZT03') {
              //已生效
              if (['copy', 'close', 'revocation'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == 'ZT07') {
              //已关闭
              if (['activate'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractStatus == 'ZT022') {
              //撤回审批中
              if (['sureRevocation', 'cancelRevocation'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (
              contractStatus == 'ZT02' ||
              contractStatus == 'ZT021' ||
              contractStatus == 'ZT023' ||
              contractStatus == 'ZT024' ||
              contractStatus == 'ZT025'
            ) {
              //审批中，修订审批中,关闭审批中，生效审批中，删除审批中
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = true;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
